// Angular
import { Component, Inject, OnInit ,ChangeDetectorRef} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import{ba1380Service}from '../../../../../Service/ba1380/ba1380-service.service'

@Component({
	selector: 'kt-delete-entity-dialog',
	templateUrl: './delete-entity-dialog.component.html'
})
export class DeleteEntityDialogComponent implements OnInit {
	// Public properties
	viewLoading = false;
	lblDelete:string;
	lblCancel:string;

	/**
	 * Component constructor
	 *
	 * @param dialogRef: MatDialogRef<DeleteEntityDialogComponent>
	 * @param data: any
	 */
	constructor(
		public dialogRef: MatDialogRef<DeleteEntityDialogComponent>,
		private changeDetectorRef: ChangeDetectorRef,
		private ba1380Service:ba1380Service,
		@Inject(MAT_DIALOG_DATA) public data: any
	) { }

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
		this.onGetCommonControlNames();
	}
	  onGetCommonControlNames()
  {
    this.ba1380Service.GetCommonControlNames(8).subscribe(CommonControlNamesList=>{
      CommonControlNamesList.forEach(data => {
        if(data.GeneralMsgId == 9)
        {
          this.lblDelete = data.Message;
        }
        else if(data.GeneralMsgId == 22)
        {
          this.lblCancel = data.Message;
        }
       
      });
      this.changeDetectorRef.detectChanges();
    })
  }

	/**
	 * Close dialog with false result
	 */
	onNoClick(): void {
		this.dialogRef.close();
	}

	/**
	 * Close dialog with true result
	 */
	onYesClick(): void {
		/* Server loading imitation. Remove this */
		this.viewLoading = true;
		setTimeout(() => {
			this.dialogRef.close(true); // Keep only this row
		}, 2500);
	}
}
